// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/admin.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AuditSnapshot, OperationResult, PageRequest, PageResponse } from "./common_pb";
import { file_live178_v1_common } from "./common_pb";
import type { AppConfig } from "./content_pb";
import { file_live178_v1_content } from "./content_pb";
import type { KycStatus, UserLevel, UserProfile, UserStatus } from "./identity_pb";
import { file_live178_v1_identity } from "./identity_pb";
import type { Notification, NotificationType } from "./notification_pb";
import { file_live178_v1_notification } from "./notification_pb";
import type { PaymentAvailability } from "./payment_pb";
import { file_live178_v1_payment } from "./payment_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/admin.proto.
 */
export const file_live178_v1_admin: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_live178_v1_common, file_live178_v1_content, file_live178_v1_identity, file_live178_v1_notification, file_live178_v1_payment]);

/**
 * @generated from message live178.v1.AdminProfile
 */
export type AdminProfile = Message<"live178.v1.AdminProfile"> & {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: live178.v1.AdminRoleCode role = 4;
   */
  role: AdminRoleCode;

  /**
   * @generated from field: repeated string permissions = 5;
   */
  permissions: string[];

  /**
   * @generated from field: string domain_scope = 6;
   */
  domainScope: string;

  /**
   * @generated from field: bool mfa_enabled = 7;
   */
  mfaEnabled: boolean;

  /**
   * @generated from field: live178.v1.AdminUserStatus status = 8;
   */
  status: AdminUserStatus;

  /**
   * @generated from field: google.protobuf.Timestamp force_logout_at = 9;
   */
  forceLogoutAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.AdminProfile.
 * Use `create(AdminProfileSchema)` to create a new message.
 */
export const AdminProfileSchema: GenMessage<AdminProfile> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 0);

/**
 * @generated from message live178.v1.AdminLoginRequest
 */
export type AdminLoginRequest = Message<"live178.v1.AdminLoginRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string domain = 3;
   */
  domain: string;

  /**
   * @generated from field: string device_fingerprint = 4;
   */
  deviceFingerprint: string;
};

/**
 * Describes the message live178.v1.AdminLoginRequest.
 * Use `create(AdminLoginRequestSchema)` to create a new message.
 */
export const AdminLoginRequestSchema: GenMessage<AdminLoginRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 1);

/**
 * @generated from message live178.v1.AdminLoginResponse
 */
export type AdminLoginResponse = Message<"live178.v1.AdminLoginResponse"> & {
  /**
   * @generated from field: string pending_token = 1;
   */
  pendingToken: string;

  /**
   * @generated from field: bool mfa_required = 2;
   */
  mfaRequired: boolean;

  /**
   * @generated from field: live178.v1.AdminProfile profile = 3;
   */
  profile?: AdminProfile | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.AdminLoginResponse.
 * Use `create(AdminLoginResponseSchema)` to create a new message.
 */
export const AdminLoginResponseSchema: GenMessage<AdminLoginResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 2);

/**
 * @generated from message live178.v1.VerifyAdminMfaRequest
 */
export type VerifyAdminMfaRequest = Message<"live178.v1.VerifyAdminMfaRequest"> & {
  /**
   * @generated from field: string pending_token = 1;
   */
  pendingToken: string;

  /**
   * @generated from field: string totp = 2;
   */
  totp: string;
};

/**
 * Describes the message live178.v1.VerifyAdminMfaRequest.
 * Use `create(VerifyAdminMfaRequestSchema)` to create a new message.
 */
export const VerifyAdminMfaRequestSchema: GenMessage<VerifyAdminMfaRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 3);

/**
 * @generated from message live178.v1.VerifyAdminMfaResponse
 */
export type VerifyAdminMfaResponse = Message<"live178.v1.VerifyAdminMfaResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: live178.v1.AdminProfile profile = 3;
   */
  profile?: AdminProfile | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp access_expires_at = 4;
   */
  accessExpiresAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.VerifyAdminMfaResponse.
 * Use `create(VerifyAdminMfaResponseSchema)` to create a new message.
 */
export const VerifyAdminMfaResponseSchema: GenMessage<VerifyAdminMfaResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 4);

/**
 * @generated from message live178.v1.RefreshAdminSessionRequest
 */
export type RefreshAdminSessionRequest = Message<"live178.v1.RefreshAdminSessionRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;

  /**
   * @generated from field: string device_fingerprint = 2;
   */
  deviceFingerprint: string;

  /**
   * @generated from field: string domain = 3;
   */
  domain: string;
};

/**
 * Describes the message live178.v1.RefreshAdminSessionRequest.
 * Use `create(RefreshAdminSessionRequestSchema)` to create a new message.
 */
export const RefreshAdminSessionRequestSchema: GenMessage<RefreshAdminSessionRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 5);

/**
 * @generated from message live178.v1.RefreshAdminSessionResponse
 */
export type RefreshAdminSessionResponse = Message<"live178.v1.RefreshAdminSessionResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: live178.v1.AdminProfile profile = 3;
   */
  profile?: AdminProfile | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp access_expires_at = 4;
   */
  accessExpiresAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.RefreshAdminSessionResponse.
 * Use `create(RefreshAdminSessionResponseSchema)` to create a new message.
 */
export const RefreshAdminSessionResponseSchema: GenMessage<RefreshAdminSessionResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 6);

/**
 * @generated from message live178.v1.LogoutAdminRequest
 */
export type LogoutAdminRequest = Message<"live178.v1.LogoutAdminRequest"> & {
  /**
   * @generated from field: bool all_sessions = 1;
   */
  allSessions: boolean;
};

/**
 * Describes the message live178.v1.LogoutAdminRequest.
 * Use `create(LogoutAdminRequestSchema)` to create a new message.
 */
export const LogoutAdminRequestSchema: GenMessage<LogoutAdminRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 7);

/**
 * @generated from message live178.v1.LogoutAdminResponse
 */
export type LogoutAdminResponse = Message<"live178.v1.LogoutAdminResponse"> & {
  /**
   * @generated from field: int32 revoked_sessions = 1;
   */
  revokedSessions: number;
};

/**
 * Describes the message live178.v1.LogoutAdminResponse.
 * Use `create(LogoutAdminResponseSchema)` to create a new message.
 */
export const LogoutAdminResponseSchema: GenMessage<LogoutAdminResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 8);

/**
 * @generated from message live178.v1.ApprovalRequest
 */
export type ApprovalRequest = Message<"live178.v1.ApprovalRequest"> & {
  /**
   * @generated from field: string approval_id = 1;
   */
  approvalId: string;

  /**
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: string target_type = 3;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 4;
   */
  targetId: string;

  /**
   * @generated from field: string requested_by = 5;
   */
  requestedBy: string;

  /**
   * @generated from field: string decided_by = 6;
   */
  decidedBy: string;

  /**
   * @generated from field: live178.v1.ApprovalStatus status = 7;
   */
  status: ApprovalStatus;

  /**
   * @generated from field: google.protobuf.Struct payload = 8;
   */
  payload?: JsonObject | undefined;

  /**
   * @generated from field: string reason = 9;
   */
  reason: string;

  /**
   * @generated from field: string decision_remark = 10;
   */
  decisionRemark: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 12;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp decided_at = 13;
   */
  decidedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.ApprovalRequest.
 * Use `create(ApprovalRequestSchema)` to create a new message.
 */
export const ApprovalRequestSchema: GenMessage<ApprovalRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 9);

/**
 * @generated from message live178.v1.AuditEntry
 */
export type AuditEntry = Message<"live178.v1.AuditEntry"> & {
  /**
   * @generated from field: string audit_id = 1;
   */
  auditId: string;

  /**
   * @generated from field: string admin_id = 2;
   */
  adminId: string;

  /**
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * @generated from field: string target_type = 4;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 5;
   */
  targetId: string;

  /**
   * @generated from field: live178.v1.AuditSnapshot snapshot = 6;
   */
  snapshot?: AuditSnapshot | undefined;

  /**
   * @generated from field: string ip_masked = 7;
   */
  ipMasked: string;

  /**
   * @generated from field: string domain = 8;
   */
  domain: string;

  /**
   * @generated from field: string request_id = 9;
   */
  requestId: string;

  /**
   * @generated from field: string reason = 10;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.AuditEntry.
 * Use `create(AuditEntrySchema)` to create a new message.
 */
export const AuditEntrySchema: GenMessage<AuditEntry> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 10);

/**
 * @generated from message live178.v1.CreateApprovalRequest
 */
export type CreateApprovalRequest = Message<"live178.v1.CreateApprovalRequest"> & {
  /**
   * @generated from field: string action = 1;
   */
  action: string;

  /**
   * @generated from field: string target_type = 2;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 3;
   */
  targetId: string;

  /**
   * @generated from field: google.protobuf.Struct payload = 4;
   */
  payload?: JsonObject | undefined;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.CreateApprovalRequest.
 * Use `create(CreateApprovalRequestSchema)` to create a new message.
 */
export const CreateApprovalRequestSchema: GenMessage<CreateApprovalRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 11);

/**
 * @generated from message live178.v1.CreateApprovalResponse
 */
export type CreateApprovalResponse = Message<"live178.v1.CreateApprovalResponse"> & {
  /**
   * @generated from field: live178.v1.ApprovalRequest approval = 1;
   */
  approval?: ApprovalRequest | undefined;
};

/**
 * Describes the message live178.v1.CreateApprovalResponse.
 * Use `create(CreateApprovalResponseSchema)` to create a new message.
 */
export const CreateApprovalResponseSchema: GenMessage<CreateApprovalResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 12);

/**
 * @generated from message live178.v1.ListApprovalsRequest
 */
export type ListApprovalsRequest = Message<"live178.v1.ListApprovalsRequest"> & {
  /**
   * @generated from field: live178.v1.ApprovalStatus status = 1;
   */
  status: ApprovalStatus;

  /**
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListApprovalsRequest.
 * Use `create(ListApprovalsRequestSchema)` to create a new message.
 */
export const ListApprovalsRequestSchema: GenMessage<ListApprovalsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 13);

/**
 * @generated from message live178.v1.ListApprovalsResponse
 */
export type ListApprovalsResponse = Message<"live178.v1.ListApprovalsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ApprovalRequest approvals = 1;
   */
  approvals: ApprovalRequest[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListApprovalsResponse.
 * Use `create(ListApprovalsResponseSchema)` to create a new message.
 */
export const ListApprovalsResponseSchema: GenMessage<ListApprovalsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 14);

/**
 * @generated from message live178.v1.DecideApprovalRequest
 */
export type DecideApprovalRequest = Message<"live178.v1.DecideApprovalRequest"> & {
  /**
   * @generated from field: string approval_id = 1;
   */
  approvalId: string;

  /**
   * @generated from field: live178.v1.ApprovalDecision decision = 2;
   */
  decision: ApprovalDecision;

  /**
   * @generated from field: string remark = 3;
   */
  remark: string;

  /**
   * @generated from field: string expected_revision = 4;
   */
  expectedRevision: string;
};

/**
 * Describes the message live178.v1.DecideApprovalRequest.
 * Use `create(DecideApprovalRequestSchema)` to create a new message.
 */
export const DecideApprovalRequestSchema: GenMessage<DecideApprovalRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 15);

/**
 * @generated from message live178.v1.DecideApprovalResponse
 */
export type DecideApprovalResponse = Message<"live178.v1.DecideApprovalResponse"> & {
  /**
   * @generated from field: live178.v1.ApprovalRequest approval = 1;
   */
  approval?: ApprovalRequest | undefined;
};

/**
 * Describes the message live178.v1.DecideApprovalResponse.
 * Use `create(DecideApprovalResponseSchema)` to create a new message.
 */
export const DecideApprovalResponseSchema: GenMessage<DecideApprovalResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 16);

/**
 * @generated from message live178.v1.ListAuditLogsRequest
 */
export type ListAuditLogsRequest = Message<"live178.v1.ListAuditLogsRequest"> & {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId: string;

  /**
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: string target_type = 3;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 4;
   */
  targetId: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 5;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListAuditLogsRequest.
 * Use `create(ListAuditLogsRequestSchema)` to create a new message.
 */
export const ListAuditLogsRequestSchema: GenMessage<ListAuditLogsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 17);

/**
 * @generated from message live178.v1.ListAuditLogsResponse
 */
export type ListAuditLogsResponse = Message<"live178.v1.ListAuditLogsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.AuditEntry entries = 1;
   */
  entries: AuditEntry[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListAuditLogsResponse.
 * Use `create(ListAuditLogsResponseSchema)` to create a new message.
 */
export const ListAuditLogsResponseSchema: GenMessage<ListAuditLogsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 18);

/**
 * @generated from message live178.v1.ForceAdminLogoutRequest
 */
export type ForceAdminLogoutRequest = Message<"live178.v1.ForceAdminLogoutRequest"> & {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.ForceAdminLogoutRequest.
 * Use `create(ForceAdminLogoutRequestSchema)` to create a new message.
 */
export const ForceAdminLogoutRequestSchema: GenMessage<ForceAdminLogoutRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 19);

/**
 * @generated from message live178.v1.ForceAdminLogoutResponse
 */
export type ForceAdminLogoutResponse = Message<"live178.v1.ForceAdminLogoutResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.ForceAdminLogoutResponse.
 * Use `create(ForceAdminLogoutResponseSchema)` to create a new message.
 */
export const ForceAdminLogoutResponseSchema: GenMessage<ForceAdminLogoutResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 20);

/**
 * @generated from message live178.v1.ListKycReviewsRequest
 */
export type ListKycReviewsRequest = Message<"live178.v1.ListKycReviewsRequest"> & {
  /**
   * @generated from field: live178.v1.KycStatus status = 1;
   */
  status: KycStatus;

  /**
   * @generated from field: live178.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListKycReviewsRequest.
 * Use `create(ListKycReviewsRequestSchema)` to create a new message.
 */
export const ListKycReviewsRequestSchema: GenMessage<ListKycReviewsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 21);

/**
 * @generated from message live178.v1.KycReviewItem
 */
export type KycReviewItem = Message<"live178.v1.KycReviewItem"> & {
  /**
   * @generated from field: string verification_id = 1;
   */
  verificationId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string real_name_masked = 3;
   */
  realNameMasked: string;

  /**
   * @generated from field: string id_card_masked = 4;
   */
  idCardMasked: string;

  /**
   * @generated from field: live178.v1.KycStatus status = 5;
   */
  status: KycStatus;

  /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 6;
   */
  submittedAt?: Timestamp | undefined;

  /**
   * @generated from field: int64 revision = 7;
   */
  revision: bigint;
};

/**
 * Describes the message live178.v1.KycReviewItem.
 * Use `create(KycReviewItemSchema)` to create a new message.
 */
export const KycReviewItemSchema: GenMessage<KycReviewItem> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 22);

/**
 * @generated from message live178.v1.ListKycReviewsResponse
 */
export type ListKycReviewsResponse = Message<"live178.v1.ListKycReviewsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.KycReviewItem items = 1;
   */
  items: KycReviewItem[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListKycReviewsResponse.
 * Use `create(ListKycReviewsResponseSchema)` to create a new message.
 */
export const ListKycReviewsResponseSchema: GenMessage<ListKycReviewsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 23);

/**
 * @generated from message live178.v1.ReviewKycRequest
 */
export type ReviewKycRequest = Message<"live178.v1.ReviewKycRequest"> & {
  /**
   * @generated from field: string verification_id = 1;
   */
  verificationId: string;

  /**
   * @generated from field: live178.v1.KycStatus decision = 2;
   */
  decision: KycStatus;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string expected_revision = 4;
   */
  expectedRevision: string;
};

/**
 * Describes the message live178.v1.ReviewKycRequest.
 * Use `create(ReviewKycRequestSchema)` to create a new message.
 */
export const ReviewKycRequestSchema: GenMessage<ReviewKycRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 24);

/**
 * @generated from message live178.v1.ReviewKycResponse
 */
export type ReviewKycResponse = Message<"live178.v1.ReviewKycResponse"> & {
  /**
   * @generated from field: live178.v1.KycReviewItem item = 1;
   */
  item?: KycReviewItem | undefined;
};

/**
 * Describes the message live178.v1.ReviewKycResponse.
 * Use `create(ReviewKycResponseSchema)` to create a new message.
 */
export const ReviewKycResponseSchema: GenMessage<ReviewKycResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 25);

/**
 * @generated from message live178.v1.GetPaymentSettingsRequest
 */
export type GetPaymentSettingsRequest = Message<"live178.v1.GetPaymentSettingsRequest"> & {
};

/**
 * Describes the message live178.v1.GetPaymentSettingsRequest.
 * Use `create(GetPaymentSettingsRequestSchema)` to create a new message.
 */
export const GetPaymentSettingsRequestSchema: GenMessage<GetPaymentSettingsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 26);

/**
 * @generated from message live178.v1.GetPaymentSettingsResponse
 */
export type GetPaymentSettingsResponse = Message<"live178.v1.GetPaymentSettingsResponse"> & {
  /**
   * @generated from field: live178.v1.PaymentAvailability settings = 1;
   */
  settings?: PaymentAvailability | undefined;
};

/**
 * Describes the message live178.v1.GetPaymentSettingsResponse.
 * Use `create(GetPaymentSettingsResponseSchema)` to create a new message.
 */
export const GetPaymentSettingsResponseSchema: GenMessage<GetPaymentSettingsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 27);

/**
 * @generated from message live178.v1.UpdatePaymentSettingsRequest
 */
export type UpdatePaymentSettingsRequest = Message<"live178.v1.UpdatePaymentSettingsRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string disabled_message = 2;
   */
  disabledMessage: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.UpdatePaymentSettingsRequest.
 * Use `create(UpdatePaymentSettingsRequestSchema)` to create a new message.
 */
export const UpdatePaymentSettingsRequestSchema: GenMessage<UpdatePaymentSettingsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 28);

/**
 * @generated from message live178.v1.UpdatePaymentSettingsResponse
 */
export type UpdatePaymentSettingsResponse = Message<"live178.v1.UpdatePaymentSettingsResponse"> & {
  /**
   * @generated from field: live178.v1.PaymentAvailability settings = 1;
   */
  settings?: PaymentAvailability | undefined;
};

/**
 * Describes the message live178.v1.UpdatePaymentSettingsResponse.
 * Use `create(UpdatePaymentSettingsResponseSchema)` to create a new message.
 */
export const UpdatePaymentSettingsResponseSchema: GenMessage<UpdatePaymentSettingsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 29);

/**
 * @generated from message live178.v1.GetAppSettingsRequest
 */
export type GetAppSettingsRequest = Message<"live178.v1.GetAppSettingsRequest"> & {
};

/**
 * Describes the message live178.v1.GetAppSettingsRequest.
 * Use `create(GetAppSettingsRequestSchema)` to create a new message.
 */
export const GetAppSettingsRequestSchema: GenMessage<GetAppSettingsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 30);

/**
 * @generated from message live178.v1.GetAppSettingsResponse
 */
export type GetAppSettingsResponse = Message<"live178.v1.GetAppSettingsResponse"> & {
  /**
   * @generated from field: live178.v1.AppConfig settings = 1;
   */
  settings?: AppConfig | undefined;
};

/**
 * Describes the message live178.v1.GetAppSettingsResponse.
 * Use `create(GetAppSettingsResponseSchema)` to create a new message.
 */
export const GetAppSettingsResponseSchema: GenMessage<GetAppSettingsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 31);

/**
 * @generated from message live178.v1.UpdateAppSettingsRequest
 */
export type UpdateAppSettingsRequest = Message<"live178.v1.UpdateAppSettingsRequest"> & {
  /**
   * @generated from field: live178.v1.AppConfig settings = 1;
   */
  settings?: AppConfig | undefined;

  /**
   * @generated from field: int64 expected_revision = 2;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.UpdateAppSettingsRequest.
 * Use `create(UpdateAppSettingsRequestSchema)` to create a new message.
 */
export const UpdateAppSettingsRequestSchema: GenMessage<UpdateAppSettingsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 32);

/**
 * @generated from message live178.v1.UpdateAppSettingsResponse
 */
export type UpdateAppSettingsResponse = Message<"live178.v1.UpdateAppSettingsResponse"> & {
  /**
   * @generated from field: live178.v1.AppConfig settings = 1;
   */
  settings?: AppConfig | undefined;
};

/**
 * Describes the message live178.v1.UpdateAppSettingsResponse.
 * Use `create(UpdateAppSettingsResponseSchema)` to create a new message.
 */
export const UpdateAppSettingsResponseSchema: GenMessage<UpdateAppSettingsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 33);

/**
 * @generated from message live178.v1.ManagedUser
 */
export type ManagedUser = Message<"live178.v1.ManagedUser"> & {
  /**
   * @generated from field: live178.v1.UserProfile profile = 1;
   */
  profile?: UserProfile | undefined;

  /**
   * @generated from field: int32 active_sessions = 2;
   */
  activeSessions: number;

  /**
   * @generated from field: int32 followed_matches = 3;
   */
  followedMatches: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_active_at = 4;
   */
  lastActiveAt?: Timestamp | undefined;

  /**
   * @generated from field: int64 revision = 5;
   */
  revision: bigint;
};

/**
 * Describes the message live178.v1.ManagedUser.
 * Use `create(ManagedUserSchema)` to create a new message.
 */
export const ManagedUserSchema: GenMessage<ManagedUser> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 34);

/**
 * @generated from message live178.v1.ListManagedUsersRequest
 */
export type ListManagedUsersRequest = Message<"live178.v1.ListManagedUsersRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: live178.v1.UserStatus status = 2;
   */
  status: UserStatus;

  /**
   * @generated from field: live178.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListManagedUsersRequest.
 * Use `create(ListManagedUsersRequestSchema)` to create a new message.
 */
export const ListManagedUsersRequestSchema: GenMessage<ListManagedUsersRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 35);

/**
 * @generated from message live178.v1.ListManagedUsersResponse
 */
export type ListManagedUsersResponse = Message<"live178.v1.ListManagedUsersResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ManagedUser users = 1;
   */
  users: ManagedUser[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListManagedUsersResponse.
 * Use `create(ListManagedUsersResponseSchema)` to create a new message.
 */
export const ListManagedUsersResponseSchema: GenMessage<ListManagedUsersResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 36);

/**
 * @generated from message live178.v1.UpdateManagedUserRequest
 */
export type UpdateManagedUserRequest = Message<"live178.v1.UpdateManagedUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string nickname = 2;
   */
  nickname: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: live178.v1.UserStatus status = 4;
   */
  status: UserStatus;

  /**
   * @generated from field: bool teen_mode = 5;
   */
  teenMode: boolean;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * @generated from field: live178.v1.UserLevel user_level = 7;
   */
  userLevel: UserLevel;

  /**
   * @generated from field: int64 expected_revision = 8;
   */
  expectedRevision: bigint;
};

/**
 * Describes the message live178.v1.UpdateManagedUserRequest.
 * Use `create(UpdateManagedUserRequestSchema)` to create a new message.
 */
export const UpdateManagedUserRequestSchema: GenMessage<UpdateManagedUserRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 37);

/**
 * @generated from message live178.v1.UpdateManagedUserResponse
 */
export type UpdateManagedUserResponse = Message<"live178.v1.UpdateManagedUserResponse"> & {
  /**
   * @generated from field: live178.v1.ManagedUser user = 1;
   */
  user?: ManagedUser | undefined;
};

/**
 * Describes the message live178.v1.UpdateManagedUserResponse.
 * Use `create(UpdateManagedUserResponseSchema)` to create a new message.
 */
export const UpdateManagedUserResponseSchema: GenMessage<UpdateManagedUserResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 38);

/**
 * @generated from message live178.v1.ManagedNotification
 */
export type ManagedNotification = Message<"live178.v1.ManagedNotification"> & {
  /**
   * @generated from field: live178.v1.Notification notification = 1;
   */
  notification?: Notification | undefined;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string user_nickname = 3;
   */
  userNickname: string;

  /**
   * @generated from field: string deduplication_key = 4;
   */
  deduplicationKey: string;

  /**
   * @generated from field: int32 push_delivery_total = 5;
   */
  pushDeliveryTotal: number;

  /**
   * @generated from field: int32 push_delivery_pending = 6;
   */
  pushDeliveryPending: number;

  /**
   * @generated from field: int32 push_delivery_delivered = 7;
   */
  pushDeliveryDelivered: number;

  /**
   * @generated from field: int32 push_delivery_dead_letters = 8;
   */
  pushDeliveryDeadLetters: number;
};

/**
 * Describes the message live178.v1.ManagedNotification.
 * Use `create(ManagedNotificationSchema)` to create a new message.
 */
export const ManagedNotificationSchema: GenMessage<ManagedNotification> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 39);

/**
 * @generated from message live178.v1.ListManagedNotificationsRequest
 */
export type ListManagedNotificationsRequest = Message<"live178.v1.ListManagedNotificationsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: live178.v1.NotificationType type = 2;
   */
  type: NotificationType;

  /**
   * @generated from field: live178.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListManagedNotificationsRequest.
 * Use `create(ListManagedNotificationsRequestSchema)` to create a new message.
 */
export const ListManagedNotificationsRequestSchema: GenMessage<ListManagedNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 40);

/**
 * @generated from message live178.v1.ListManagedNotificationsResponse
 */
export type ListManagedNotificationsResponse = Message<"live178.v1.ListManagedNotificationsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ManagedNotification notifications = 1;
   */
  notifications: ManagedNotification[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListManagedNotificationsResponse.
 * Use `create(ListManagedNotificationsResponseSchema)` to create a new message.
 */
export const ListManagedNotificationsResponseSchema: GenMessage<ListManagedNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 41);

/**
 * @generated from message live178.v1.SendManagedNotificationsRequest
 */
export type SendManagedNotificationsRequest = Message<"live178.v1.SendManagedNotificationsRequest"> & {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[];

  /**
   * @generated from field: live178.v1.NotificationType type = 2;
   */
  type: NotificationType;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: string target_url = 5;
   */
  targetUrl: string;

  /**
   * @generated from field: string deduplication_key = 6;
   */
  deduplicationKey: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 7;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: string reason = 8;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.SendManagedNotificationsRequest.
 * Use `create(SendManagedNotificationsRequestSchema)` to create a new message.
 */
export const SendManagedNotificationsRequestSchema: GenMessage<SendManagedNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 42);

/**
 * @generated from message live178.v1.SendManagedNotificationsResponse
 */
export type SendManagedNotificationsResponse = Message<"live178.v1.SendManagedNotificationsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ManagedNotification notifications = 1;
   */
  notifications: ManagedNotification[];

  /**
   * @generated from field: int32 created_count = 2;
   */
  createdCount: number;

  /**
   * @generated from field: int32 deduplicated_count = 3;
   */
  deduplicatedCount: number;

  /**
   * @generated from field: int32 push_queued_count = 4;
   */
  pushQueuedCount: number;
};

/**
 * Describes the message live178.v1.SendManagedNotificationsResponse.
 * Use `create(SendManagedNotificationsResponseSchema)` to create a new message.
 */
export const SendManagedNotificationsResponseSchema: GenMessage<SendManagedNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 43);

/**
 * @generated from message live178.v1.AdminRole
 */
export type AdminRole = Message<"live178.v1.AdminRole"> & {
  /**
   * @generated from field: live178.v1.AdminRoleCode role = 1;
   */
  role: AdminRoleCode;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string domain_scope = 3;
   */
  domainScope: string;

  /**
   * @generated from field: int32 session_idle_minutes = 4;
   */
  sessionIdleMinutes: number;

  /**
   * @generated from field: bool mfa_required = 5;
   */
  mfaRequired: boolean;

  /**
   * @generated from field: bool ip_allowlist_required = 6;
   */
  ipAllowlistRequired: boolean;

  /**
   * @generated from field: repeated string permissions = 7;
   */
  permissions: string[];

  /**
   * @generated from field: int32 administrator_count = 8;
   */
  administratorCount: number;

  /**
   * @generated from field: int64 revision = 9;
   */
  revision: bigint;
};

/**
 * Describes the message live178.v1.AdminRole.
 * Use `create(AdminRoleSchema)` to create a new message.
 */
export const AdminRoleSchema: GenMessage<AdminRole> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 44);

/**
 * @generated from message live178.v1.AdminPermission
 */
export type AdminPermission = Message<"live178.v1.AdminPermission"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: live178.v1.AdminPermissionType permission_type = 3;
   */
  permissionType: AdminPermissionType;

  /**
   * @generated from field: bool high_risk = 4;
   */
  highRisk: boolean;
};

/**
 * Describes the message live178.v1.AdminPermission.
 * Use `create(AdminPermissionSchema)` to create a new message.
 */
export const AdminPermissionSchema: GenMessage<AdminPermission> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 45);

/**
 * @generated from message live178.v1.ListAdminPermissionsRequest
 */
export type ListAdminPermissionsRequest = Message<"live178.v1.ListAdminPermissionsRequest"> & {
};

/**
 * Describes the message live178.v1.ListAdminPermissionsRequest.
 * Use `create(ListAdminPermissionsRequestSchema)` to create a new message.
 */
export const ListAdminPermissionsRequestSchema: GenMessage<ListAdminPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 46);

/**
 * @generated from message live178.v1.ListAdminPermissionsResponse
 */
export type ListAdminPermissionsResponse = Message<"live178.v1.ListAdminPermissionsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.AdminPermission permissions = 1;
   */
  permissions: AdminPermission[];
};

/**
 * Describes the message live178.v1.ListAdminPermissionsResponse.
 * Use `create(ListAdminPermissionsResponseSchema)` to create a new message.
 */
export const ListAdminPermissionsResponseSchema: GenMessage<ListAdminPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 47);

/**
 * @generated from message live178.v1.AdminAccount
 */
export type AdminAccount = Message<"live178.v1.AdminAccount"> & {
  /**
   * @generated from field: live178.v1.AdminProfile profile = 1;
   */
  profile?: AdminProfile | undefined;

  /**
   * @generated from field: repeated string allowed_ip_cidrs = 2;
   */
  allowedIpCidrs: string[];

  /**
   * @generated from field: string creator_user_id = 3;
   */
  creatorUserId: string;

  /**
   * @generated from field: int32 active_sessions = 4;
   */
  activeSessions: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_login_at = 5;
   */
  lastLoginAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: int64 revision = 8;
   */
  revision: bigint;
};

/**
 * Describes the message live178.v1.AdminAccount.
 * Use `create(AdminAccountSchema)` to create a new message.
 */
export const AdminAccountSchema: GenMessage<AdminAccount> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 48);

/**
 * @generated from message live178.v1.ListAdminRolesRequest
 */
export type ListAdminRolesRequest = Message<"live178.v1.ListAdminRolesRequest"> & {
};

/**
 * Describes the message live178.v1.ListAdminRolesRequest.
 * Use `create(ListAdminRolesRequestSchema)` to create a new message.
 */
export const ListAdminRolesRequestSchema: GenMessage<ListAdminRolesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 49);

/**
 * @generated from message live178.v1.ListAdminRolesResponse
 */
export type ListAdminRolesResponse = Message<"live178.v1.ListAdminRolesResponse"> & {
  /**
   * @generated from field: repeated live178.v1.AdminRole roles = 1;
   */
  roles: AdminRole[];
};

/**
 * Describes the message live178.v1.ListAdminRolesResponse.
 * Use `create(ListAdminRolesResponseSchema)` to create a new message.
 */
export const ListAdminRolesResponseSchema: GenMessage<ListAdminRolesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 50);

/**
 * @generated from message live178.v1.UpdateAdminRolePermissionsRequest
 */
export type UpdateAdminRolePermissionsRequest = Message<"live178.v1.UpdateAdminRolePermissionsRequest"> & {
  /**
   * @generated from field: live178.v1.AdminRoleCode role = 1;
   */
  role: AdminRoleCode;

  /**
   * @generated from field: repeated string permissions = 2;
   */
  permissions: string[];

  /**
   * @generated from field: int64 expected_revision = 3;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string approval_id = 4;
   */
  approvalId: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.UpdateAdminRolePermissionsRequest.
 * Use `create(UpdateAdminRolePermissionsRequestSchema)` to create a new message.
 */
export const UpdateAdminRolePermissionsRequestSchema: GenMessage<UpdateAdminRolePermissionsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 51);

/**
 * @generated from message live178.v1.UpdateAdminRolePermissionsResponse
 */
export type UpdateAdminRolePermissionsResponse = Message<"live178.v1.UpdateAdminRolePermissionsResponse"> & {
  /**
   * @generated from field: live178.v1.AdminRole role = 1;
   */
  role?: AdminRole | undefined;
};

/**
 * Describes the message live178.v1.UpdateAdminRolePermissionsResponse.
 * Use `create(UpdateAdminRolePermissionsResponseSchema)` to create a new message.
 */
export const UpdateAdminRolePermissionsResponseSchema: GenMessage<UpdateAdminRolePermissionsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 52);

/**
 * @generated from message live178.v1.ListAdminAccountsRequest
 */
export type ListAdminAccountsRequest = Message<"live178.v1.ListAdminAccountsRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: live178.v1.AdminRoleCode role = 2;
   */
  role: AdminRoleCode;

  /**
   * @generated from field: live178.v1.AdminUserStatus status = 3;
   */
  status: AdminUserStatus;

  /**
   * @generated from field: live178.v1.PageRequest page = 4;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListAdminAccountsRequest.
 * Use `create(ListAdminAccountsRequestSchema)` to create a new message.
 */
export const ListAdminAccountsRequestSchema: GenMessage<ListAdminAccountsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 53);

/**
 * @generated from message live178.v1.ListAdminAccountsResponse
 */
export type ListAdminAccountsResponse = Message<"live178.v1.ListAdminAccountsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.AdminAccount accounts = 1;
   */
  accounts: AdminAccount[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListAdminAccountsResponse.
 * Use `create(ListAdminAccountsResponseSchema)` to create a new message.
 */
export const ListAdminAccountsResponseSchema: GenMessage<ListAdminAccountsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 54);

/**
 * @generated from message live178.v1.CreateAdminAccountRequest
 */
export type CreateAdminAccountRequest = Message<"live178.v1.CreateAdminAccountRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string initial_password = 3;
   */
  initialPassword: string;

  /**
   * @generated from field: live178.v1.AdminRoleCode role = 4;
   */
  role: AdminRoleCode;

  /**
   * @generated from field: repeated string allowed_ip_cidrs = 5;
   */
  allowedIpCidrs: string[];

  /**
   * @generated from field: string creator_user_id = 6;
   */
  creatorUserId: string;

  /**
   * @generated from field: string reason = 7;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.CreateAdminAccountRequest.
 * Use `create(CreateAdminAccountRequestSchema)` to create a new message.
 */
export const CreateAdminAccountRequestSchema: GenMessage<CreateAdminAccountRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 55);

/**
 * @generated from message live178.v1.CreateAdminAccountResponse
 */
export type CreateAdminAccountResponse = Message<"live178.v1.CreateAdminAccountResponse"> & {
  /**
   * @generated from field: live178.v1.AdminAccount account = 1;
   */
  account?: AdminAccount | undefined;

  /**
   * @generated from field: string mfa_enrollment_secret = 2;
   */
  mfaEnrollmentSecret: string;

  /**
   * @generated from field: string mfa_provisioning_uri = 3;
   */
  mfaProvisioningUri: string;
};

/**
 * Describes the message live178.v1.CreateAdminAccountResponse.
 * Use `create(CreateAdminAccountResponseSchema)` to create a new message.
 */
export const CreateAdminAccountResponseSchema: GenMessage<CreateAdminAccountResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 56);

/**
 * @generated from message live178.v1.UpdateAdminAccountRequest
 */
export type UpdateAdminAccountRequest = Message<"live178.v1.UpdateAdminAccountRequest"> & {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: live178.v1.AdminRoleCode role = 3;
   */
  role: AdminRoleCode;

  /**
   * @generated from field: live178.v1.AdminUserStatus status = 4;
   */
  status: AdminUserStatus;

  /**
   * @generated from field: repeated string allowed_ip_cidrs = 5;
   */
  allowedIpCidrs: string[];

  /**
   * @generated from field: string new_password = 6;
   */
  newPassword: string;

  /**
   * @generated from field: int64 expected_revision = 7;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string reason = 8;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.UpdateAdminAccountRequest.
 * Use `create(UpdateAdminAccountRequestSchema)` to create a new message.
 */
export const UpdateAdminAccountRequestSchema: GenMessage<UpdateAdminAccountRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 57);

/**
 * @generated from message live178.v1.UpdateAdminAccountResponse
 */
export type UpdateAdminAccountResponse = Message<"live178.v1.UpdateAdminAccountResponse"> & {
  /**
   * @generated from field: live178.v1.AdminAccount account = 1;
   */
  account?: AdminAccount | undefined;
};

/**
 * Describes the message live178.v1.UpdateAdminAccountResponse.
 * Use `create(UpdateAdminAccountResponseSchema)` to create a new message.
 */
export const UpdateAdminAccountResponseSchema: GenMessage<UpdateAdminAccountResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 58);

/**
 * @generated from message live178.v1.ManagedLiveSource
 */
export type ManagedLiveSource = Message<"live178.v1.ManagedLiveSource"> & {
  /**
   * @generated from field: string source_id = 1;
   */
  sourceId: string;

  /**
   * @generated from field: string source_key = 2;
   */
  sourceKey: string;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;

  /**
   * @generated from field: string match_id = 4;
   */
  matchId: string;

  /**
   * @generated from field: string anchor_id = 5;
   */
  anchorId: string;

  /**
   * @generated from field: string anchor_name = 6;
   */
  anchorName: string;

  /**
   * @generated from field: string room_title = 7;
   */
  roomTitle: string;

  /**
   * @generated from field: string cover_url = 8;
   */
  coverUrl: string;

  /**
   * @generated from field: string label = 9;
   */
  label: string;

  /**
   * @generated from field: string format = 10;
   */
  format: string;

  /**
   * @generated from field: string url = 11;
   */
  url: string;

  /**
   * @generated from field: int32 priority = 12;
   */
  priority: number;

  /**
   * @generated from field: bool is_default = 13;
   */
  isDefault: boolean;

  /**
   * @generated from field: bool enabled = 14;
   */
  enabled: boolean;

  /**
   * @generated from field: int32 width = 15;
   */
  width: number;

  /**
   * @generated from field: int32 height = 16;
   */
  height: number;

  /**
   * @generated from field: int32 fps = 17;
   */
  fps: number;

  /**
   * @generated from field: int64 bitrate_bps = 18;
   */
  bitrateBps: bigint;

  /**
   * @generated from field: string codec = 19;
   */
  codec: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 21;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.ManagedLiveSource.
 * Use `create(ManagedLiveSourceSchema)` to create a new message.
 */
export const ManagedLiveSourceSchema: GenMessage<ManagedLiveSource> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 59);

/**
 * @generated from message live178.v1.ListManagedLiveSourcesRequest
 */
export type ListManagedLiveSourcesRequest = Message<"live178.v1.ListManagedLiveSourcesRequest"> & {
  /**
   * @generated from field: string match_id = 1;
   */
  matchId: string;

  /**
   * @generated from field: bool include_disabled = 2;
   */
  includeDisabled: boolean;

  /**
   * @generated from field: live178.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListManagedLiveSourcesRequest.
 * Use `create(ListManagedLiveSourcesRequestSchema)` to create a new message.
 */
export const ListManagedLiveSourcesRequestSchema: GenMessage<ListManagedLiveSourcesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 60);

/**
 * @generated from message live178.v1.ListManagedLiveSourcesResponse
 */
export type ListManagedLiveSourcesResponse = Message<"live178.v1.ListManagedLiveSourcesResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ManagedLiveSource sources = 1;
   */
  sources: ManagedLiveSource[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListManagedLiveSourcesResponse.
 * Use `create(ListManagedLiveSourcesResponseSchema)` to create a new message.
 */
export const ListManagedLiveSourcesResponseSchema: GenMessage<ListManagedLiveSourcesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 61);

/**
 * @generated from message live178.v1.UpsertManagedLiveSourceRequest
 */
export type UpsertManagedLiveSourceRequest = Message<"live178.v1.UpsertManagedLiveSourceRequest"> & {
  /**
   * @generated from field: live178.v1.ManagedLiveSource source = 1;
   */
  source?: ManagedLiveSource | undefined;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.UpsertManagedLiveSourceRequest.
 * Use `create(UpsertManagedLiveSourceRequestSchema)` to create a new message.
 */
export const UpsertManagedLiveSourceRequestSchema: GenMessage<UpsertManagedLiveSourceRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 62);

/**
 * @generated from message live178.v1.UpsertManagedLiveSourceResponse
 */
export type UpsertManagedLiveSourceResponse = Message<"live178.v1.UpsertManagedLiveSourceResponse"> & {
  /**
   * @generated from field: live178.v1.ManagedLiveSource source = 1;
   */
  source?: ManagedLiveSource | undefined;

  /**
   * @generated from field: bool created = 2;
   */
  created: boolean;
};

/**
 * Describes the message live178.v1.UpsertManagedLiveSourceResponse.
 * Use `create(UpsertManagedLiveSourceResponseSchema)` to create a new message.
 */
export const UpsertManagedLiveSourceResponseSchema: GenMessage<UpsertManagedLiveSourceResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 63);

/**
 * @generated from message live178.v1.DisableManagedLiveSourceRequest
 */
export type DisableManagedLiveSourceRequest = Message<"live178.v1.DisableManagedLiveSourceRequest"> & {
  /**
   * @generated from field: string source_key = 1;
   */
  sourceKey: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.DisableManagedLiveSourceRequest.
 * Use `create(DisableManagedLiveSourceRequestSchema)` to create a new message.
 */
export const DisableManagedLiveSourceRequestSchema: GenMessage<DisableManagedLiveSourceRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 64);

/**
 * @generated from message live178.v1.DisableManagedLiveSourceResponse
 */
export type DisableManagedLiveSourceResponse = Message<"live178.v1.DisableManagedLiveSourceResponse"> & {
  /**
   * @generated from field: live178.v1.ManagedLiveSource source = 1;
   */
  source?: ManagedLiveSource | undefined;
};

/**
 * Describes the message live178.v1.DisableManagedLiveSourceResponse.
 * Use `create(DisableManagedLiveSourceResponseSchema)` to create a new message.
 */
export const DisableManagedLiveSourceResponseSchema: GenMessage<DisableManagedLiveSourceResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 65);

/**
 * @generated from message live178.v1.ManagedReport
 */
export type ManagedReport = Message<"live178.v1.ManagedReport"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string reporter_user_id = 2;
   */
  reporterUserId: string;

  /**
   * @generated from field: string target_type = 3;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 4;
   */
  targetId: string;

  /**
   * @generated from field: string reason_code = 5;
   */
  reasonCode: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: repeated string evidence_asset_ids = 7;
   */
  evidenceAssetIds: string[];

  /**
   * @generated from field: string status = 8;
   */
  status: string;

  /**
   * @generated from field: string assigned_admin_id = 9;
   */
  assignedAdminId: string;

  /**
   * @generated from field: string resolution = 10;
   */
  resolution: string;

  /**
   * @generated from field: int64 revision = 11;
   */
  revision: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.ManagedReport.
 * Use `create(ManagedReportSchema)` to create a new message.
 */
export const ManagedReportSchema: GenMessage<ManagedReport> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 66);

/**
 * @generated from message live178.v1.ListManagedReportsRequest
 */
export type ListManagedReportsRequest = Message<"live178.v1.ListManagedReportsRequest"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: string target_type = 2;
   */
  targetType: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListManagedReportsRequest.
 * Use `create(ListManagedReportsRequestSchema)` to create a new message.
 */
export const ListManagedReportsRequestSchema: GenMessage<ListManagedReportsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 67);

/**
 * @generated from message live178.v1.ListManagedReportsResponse
 */
export type ListManagedReportsResponse = Message<"live178.v1.ListManagedReportsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ManagedReport reports = 1;
   */
  reports: ManagedReport[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListManagedReportsResponse.
 * Use `create(ListManagedReportsResponseSchema)` to create a new message.
 */
export const ListManagedReportsResponseSchema: GenMessage<ListManagedReportsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 68);

/**
 * @generated from message live178.v1.UpdateManagedReportRequest
 */
export type UpdateManagedReportRequest = Message<"live178.v1.UpdateManagedReportRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string resolution = 3;
   */
  resolution: string;

  /**
   * @generated from field: int64 expected_revision = 4;
   */
  expectedRevision: bigint;
};

/**
 * Describes the message live178.v1.UpdateManagedReportRequest.
 * Use `create(UpdateManagedReportRequestSchema)` to create a new message.
 */
export const UpdateManagedReportRequestSchema: GenMessage<UpdateManagedReportRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 69);

/**
 * @generated from message live178.v1.UpdateManagedReportResponse
 */
export type UpdateManagedReportResponse = Message<"live178.v1.UpdateManagedReportResponse"> & {
  /**
   * @generated from field: live178.v1.ManagedReport report = 1;
   */
  report?: ManagedReport | undefined;
};

/**
 * Describes the message live178.v1.UpdateManagedReportResponse.
 * Use `create(UpdateManagedReportResponseSchema)` to create a new message.
 */
export const UpdateManagedReportResponseSchema: GenMessage<UpdateManagedReportResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 70);

/**
 * @generated from message live178.v1.ReleaseGateReadiness
 */
export type ReleaseGateReadiness = Message<"live178.v1.ReleaseGateReadiness"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string scope = 4;
   */
  scope: string;

  /**
   * @generated from field: bool required = 5;
   */
  required: boolean;

  /**
   * @generated from field: repeated string allowed_issuers = 6;
   */
  allowedIssuers: string[];

  /**
   * @generated from field: int32 max_evidence_age_hours = 7;
   */
  maxEvidenceAgeHours: number;

  /**
   * @generated from field: int32 minimum_approvals = 8;
   */
  minimumApprovals: number;

  /**
   * @generated from field: repeated string required_approval_roles = 9;
   */
  requiredApprovalRoles: string[];

  /**
   * @generated from field: string status = 10;
   */
  status: string;

  /**
   * @generated from field: string reason = 11;
   */
  reason: string;

  /**
   * @generated from field: string issuer = 12;
   */
  issuer: string;
};

/**
 * Describes the message live178.v1.ReleaseGateReadiness.
 * Use `create(ReleaseGateReadinessSchema)` to create a new message.
 */
export const ReleaseGateReadinessSchema: GenMessage<ReleaseGateReadiness> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 71);

/**
 * @generated from message live178.v1.GetReleaseReadinessRequest
 */
export type GetReleaseReadinessRequest = Message<"live178.v1.GetReleaseReadinessRequest"> & {
  /**
   * @generated from field: string release_subject = 1;
   */
  releaseSubject: string;
};

/**
 * Describes the message live178.v1.GetReleaseReadinessRequest.
 * Use `create(GetReleaseReadinessRequestSchema)` to create a new message.
 */
export const GetReleaseReadinessRequestSchema: GenMessage<GetReleaseReadinessRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 72);

/**
 * @generated from message live178.v1.GetReleaseReadinessResponse
 */
export type GetReleaseReadinessResponse = Message<"live178.v1.GetReleaseReadinessResponse"> & {
  /**
   * @generated from field: string policy_version = 1;
   */
  policyVersion: string;

  /**
   * @generated from field: string policy_sha256 = 2;
   */
  policySha256: string;

  /**
   * @generated from field: string environment = 3;
   */
  environment: string;

  /**
   * @generated from field: string release_subject = 4;
   */
  releaseSubject: string;

  /**
   * @generated from field: google.protobuf.Timestamp evaluated_at = 5;
   */
  evaluatedAt?: Timestamp | undefined;

  /**
   * @generated from field: string decision = 6;
   */
  decision: string;

  /**
   * @generated from field: int32 required_passed = 7;
   */
  requiredPassed: number;

  /**
   * @generated from field: int32 required_total = 8;
   */
  requiredTotal: number;

  /**
   * @generated from field: repeated live178.v1.ReleaseGateReadiness gates = 9;
   */
  gates: ReleaseGateReadiness[];
};

/**
 * Describes the message live178.v1.GetReleaseReadinessResponse.
 * Use `create(GetReleaseReadinessResponseSchema)` to create a new message.
 */
export const GetReleaseReadinessResponseSchema: GenMessage<GetReleaseReadinessResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_admin, 73);

/**
 * @generated from enum live178.v1.AdminRoleCode
 */
export enum AdminRoleCode {
  /**
   * @generated from enum value: ADMIN_ROLE_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADMIN_ROLE_CODE_SUPER_ADMIN = 1;
   */
  SUPER_ADMIN = 1,

  /**
   * @generated from enum value: ADMIN_ROLE_CODE_OPERATOR = 2;
   */
  OPERATOR = 2,

  /**
   * @generated from enum value: ADMIN_ROLE_CODE_MODERATOR = 3;
   */
  MODERATOR = 3,

  /**
   * @generated from enum value: ADMIN_ROLE_CODE_FINANCE = 4;
   */
  FINANCE = 4,

  /**
   * @generated from enum value: ADMIN_ROLE_CODE_CREATOR = 5;
   */
  CREATOR = 5,

  /**
   * @generated from enum value: ADMIN_ROLE_CODE_AUDITOR = 6;
   */
  AUDITOR = 6,
}

/**
 * Describes the enum live178.v1.AdminRoleCode.
 */
export const AdminRoleCodeSchema: GenEnum<AdminRoleCode> = /*@__PURE__*/
  enumDesc(file_live178_v1_admin, 0);

/**
 * @generated from enum live178.v1.AdminUserStatus
 */
export enum AdminUserStatus {
  /**
   * @generated from enum value: ADMIN_USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADMIN_USER_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: ADMIN_USER_STATUS_LOCKED = 2;
   */
  LOCKED = 2,

  /**
   * @generated from enum value: ADMIN_USER_STATUS_DISABLED = 3;
   */
  DISABLED = 3,
}

/**
 * Describes the enum live178.v1.AdminUserStatus.
 */
export const AdminUserStatusSchema: GenEnum<AdminUserStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_admin, 1);

/**
 * @generated from enum live178.v1.AdminPermissionType
 */
export enum AdminPermissionType {
  /**
   * @generated from enum value: ADMIN_PERMISSION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADMIN_PERMISSION_TYPE_READ = 1;
   */
  READ = 1,

  /**
   * @generated from enum value: ADMIN_PERMISSION_TYPE_WRITE = 2;
   */
  WRITE = 2,
}

/**
 * Describes the enum live178.v1.AdminPermissionType.
 */
export const AdminPermissionTypeSchema: GenEnum<AdminPermissionType> = /*@__PURE__*/
  enumDesc(file_live178_v1_admin, 2);

/**
 * @generated from enum live178.v1.ApprovalStatus
 */
export enum ApprovalStatus {
  /**
   * @generated from enum value: APPROVAL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: APPROVAL_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: APPROVAL_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: APPROVAL_STATUS_REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * @generated from enum value: APPROVAL_STATUS_EXECUTED = 4;
   */
  EXECUTED = 4,

  /**
   * @generated from enum value: APPROVAL_STATUS_EXPIRED = 5;
   */
  EXPIRED = 5,

  /**
   * @generated from enum value: APPROVAL_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,
}

/**
 * Describes the enum live178.v1.ApprovalStatus.
 */
export const ApprovalStatusSchema: GenEnum<ApprovalStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_admin, 3);

/**
 * @generated from enum live178.v1.ApprovalDecision
 */
export enum ApprovalDecision {
  /**
   * @generated from enum value: APPROVAL_DECISION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: APPROVAL_DECISION_APPROVE = 1;
   */
  APPROVE = 1,

  /**
   * @generated from enum value: APPROVAL_DECISION_REJECT = 2;
   */
  REJECT = 2,
}

/**
 * Describes the enum live178.v1.ApprovalDecision.
 */
export const ApprovalDecisionSchema: GenEnum<ApprovalDecision> = /*@__PURE__*/
  enumDesc(file_live178_v1_admin, 4);

/**
 * @generated from service live178.v1.AdminService
 */
export const AdminService: GenService<{
  /**
   * @generated from rpc live178.v1.AdminService.AdminLogin
   */
  adminLogin: {
    methodKind: "unary";
    input: typeof AdminLoginRequestSchema;
    output: typeof AdminLoginResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.VerifyAdminMfa
   */
  verifyAdminMfa: {
    methodKind: "unary";
    input: typeof VerifyAdminMfaRequestSchema;
    output: typeof VerifyAdminMfaResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.RefreshAdminSession
   */
  refreshAdminSession: {
    methodKind: "unary";
    input: typeof RefreshAdminSessionRequestSchema;
    output: typeof RefreshAdminSessionResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.LogoutAdmin
   */
  logoutAdmin: {
    methodKind: "unary";
    input: typeof LogoutAdminRequestSchema;
    output: typeof LogoutAdminResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.CreateApproval
   */
  createApproval: {
    methodKind: "unary";
    input: typeof CreateApprovalRequestSchema;
    output: typeof CreateApprovalResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListApprovals
   */
  listApprovals: {
    methodKind: "unary";
    input: typeof ListApprovalsRequestSchema;
    output: typeof ListApprovalsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.DecideApproval
   */
  decideApproval: {
    methodKind: "unary";
    input: typeof DecideApprovalRequestSchema;
    output: typeof DecideApprovalResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListAuditLogs
   */
  listAuditLogs: {
    methodKind: "unary";
    input: typeof ListAuditLogsRequestSchema;
    output: typeof ListAuditLogsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ForceAdminLogout
   */
  forceAdminLogout: {
    methodKind: "unary";
    input: typeof ForceAdminLogoutRequestSchema;
    output: typeof ForceAdminLogoutResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListKycReviews
   */
  listKycReviews: {
    methodKind: "unary";
    input: typeof ListKycReviewsRequestSchema;
    output: typeof ListKycReviewsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ReviewKyc
   */
  reviewKyc: {
    methodKind: "unary";
    input: typeof ReviewKycRequestSchema;
    output: typeof ReviewKycResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.GetPaymentSettings
   */
  getPaymentSettings: {
    methodKind: "unary";
    input: typeof GetPaymentSettingsRequestSchema;
    output: typeof GetPaymentSettingsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.UpdatePaymentSettings
   */
  updatePaymentSettings: {
    methodKind: "unary";
    input: typeof UpdatePaymentSettingsRequestSchema;
    output: typeof UpdatePaymentSettingsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.GetAppSettings
   */
  getAppSettings: {
    methodKind: "unary";
    input: typeof GetAppSettingsRequestSchema;
    output: typeof GetAppSettingsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.UpdateAppSettings
   */
  updateAppSettings: {
    methodKind: "unary";
    input: typeof UpdateAppSettingsRequestSchema;
    output: typeof UpdateAppSettingsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListManagedUsers
   */
  listManagedUsers: {
    methodKind: "unary";
    input: typeof ListManagedUsersRequestSchema;
    output: typeof ListManagedUsersResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.UpdateManagedUser
   */
  updateManagedUser: {
    methodKind: "unary";
    input: typeof UpdateManagedUserRequestSchema;
    output: typeof UpdateManagedUserResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListManagedNotifications
   */
  listManagedNotifications: {
    methodKind: "unary";
    input: typeof ListManagedNotificationsRequestSchema;
    output: typeof ListManagedNotificationsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.SendManagedNotifications
   */
  sendManagedNotifications: {
    methodKind: "unary";
    input: typeof SendManagedNotificationsRequestSchema;
    output: typeof SendManagedNotificationsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListAdminRoles
   */
  listAdminRoles: {
    methodKind: "unary";
    input: typeof ListAdminRolesRequestSchema;
    output: typeof ListAdminRolesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListAdminPermissions
   */
  listAdminPermissions: {
    methodKind: "unary";
    input: typeof ListAdminPermissionsRequestSchema;
    output: typeof ListAdminPermissionsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.UpdateAdminRolePermissions
   */
  updateAdminRolePermissions: {
    methodKind: "unary";
    input: typeof UpdateAdminRolePermissionsRequestSchema;
    output: typeof UpdateAdminRolePermissionsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListAdminAccounts
   */
  listAdminAccounts: {
    methodKind: "unary";
    input: typeof ListAdminAccountsRequestSchema;
    output: typeof ListAdminAccountsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.CreateAdminAccount
   */
  createAdminAccount: {
    methodKind: "unary";
    input: typeof CreateAdminAccountRequestSchema;
    output: typeof CreateAdminAccountResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.UpdateAdminAccount
   */
  updateAdminAccount: {
    methodKind: "unary";
    input: typeof UpdateAdminAccountRequestSchema;
    output: typeof UpdateAdminAccountResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListManagedLiveSources
   */
  listManagedLiveSources: {
    methodKind: "unary";
    input: typeof ListManagedLiveSourcesRequestSchema;
    output: typeof ListManagedLiveSourcesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.UpsertManagedLiveSource
   */
  upsertManagedLiveSource: {
    methodKind: "unary";
    input: typeof UpsertManagedLiveSourceRequestSchema;
    output: typeof UpsertManagedLiveSourceResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.DisableManagedLiveSource
   */
  disableManagedLiveSource: {
    methodKind: "unary";
    input: typeof DisableManagedLiveSourceRequestSchema;
    output: typeof DisableManagedLiveSourceResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.ListManagedReports
   */
  listManagedReports: {
    methodKind: "unary";
    input: typeof ListManagedReportsRequestSchema;
    output: typeof ListManagedReportsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.UpdateManagedReport
   */
  updateManagedReport: {
    methodKind: "unary";
    input: typeof UpdateManagedReportRequestSchema;
    output: typeof UpdateManagedReportResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.AdminService.GetReleaseReadiness
   */
  getReleaseReadiness: {
    methodKind: "unary";
    input: typeof GetReleaseReadinessRequestSchema;
    output: typeof GetReleaseReadinessResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_live178_v1_admin, 0);

